const data = [
  {
    id: 1,
    iconClass: "fas fa-microchip",
    title: "HDI PCB ARCHITECTURE",
    desc: "Architecting High-Density Interconnect (HDI) boards with strict impedance control for high-stress aerospace and robotic environments.",
    specs: [
      "Rigid-Flex & Multi-layer Stackups",
      "Power Delivery Network (PDN) Design",
      "Dense BGA Routing for Microcontrollers"
    ],
    tags: ["Altium Designer", "Signal Integrity", "Schematics"]
  },
  {
    id: 2,
    iconClass: "fas fa-fighter-jet",
    title: "AEROSPACE & VTOL R&D",
    desc: "Spearheading UAV architecture, specifically focusing on the complex physical transitions between vertical hover and horizontal forward flight.",
    specs: [
      "Transwing Tilt-Rotor Mechanisms",
      "Dynamic CG Payload Distribution",
      "Flight Dynamics & PID Tuning"
    ],
    tags: ["SN-21 VTOL", "UAV", "ArduPilot"]
  },
  {
    id: 3,
    iconClass: "fas fa-microcode",
    title: "BARE-METAL FIRMWARE",
    desc: "Writing highly efficient, deterministic C/C++ code and implementing real-time operating systems for mission-critical hardware.",
    specs: [
      "ARM Cortex-M Architecture",
      "DMA over I2C / SPI / UART",
      "Hardware-in-the-Loop (HIL) Testing"
    ],
    tags: ["STM32", "Embedded C", "C++"]
  },
  {
    id: 4,
    iconClass: "fas fa-robot",
    title: "COMPETITIVE ROBOTICS",
    desc: "Designing and programming highly autonomous Line Follower Robots (LFR) and specialized mechatronic systems for international competition.",
    specs: [
      "High-Speed Sensor Array Processing",
      "Dynamic Motor Kinematics",
      "Rapid Prototyping & Iteration"
    ],
    tags: ["WRO 2025 Singapore", "LFR", "Team Echo Drift"]
  },
  {
    id: 5,
    iconClass: "fas fa-cube",
    title: "KINEMATIC MODELING",
    desc: "Advanced 3D mechanical modeling, generative design, and stress simulation to optimize strength-to-weight ratios in moving assemblies.",
    specs: [
      "Aerodynamic Frame Design",
      "FEA Structural Failure Analysis",
      "Multi-axis Gear Kinematics"
    ],
    tags: ["SOLIDWORKS", "3D CAD", "FEA"]
  },
  {
    id: 6,
    iconClass: "fas fa-users-cog",
    title: "SYSTEMS LEADERSHIP",
    desc: "Leading cross-functional engineering teams, managing the complete hardware lifecycle from theoretical algorithms to physical deployment.",
    specs: [
      "Cross-disciplinary Integration",
      "Agile Hardware Development",
      "System Architecture Blueprints"
    ],
    tags: ["Team RoboMore", "Team Dynamic Spark", "Project Lead"]
  }
];

export default data;